import APIClient from "../../../common/APIClient";
import qs from "qs";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  MAX_ITEMS_IN_PAGE,
  ERROR_ALERT,
} from "../commonActions";
import {
  createUserCostCenter,
  updateUserCostCenter,
} from "../cost_centers/userCostCenterActions";
import { fetchMemberProjects } from "../projects/projectMembersActions";
import { Cache } from "aws-amplify";

const USERS_SET_FIELD_VALUE = "USERS_SET_FIELD_VALUE";
const RESET_USER = "RESET_USER";
const SET_USER = "SET_USER";
const USER_LOGIN_FIELD_VALUE = "USER_LOGIN_FIELD_VALUE";
const USER_RESET_PASSWORD_FIELD_VALUE = "USER_RESET_PASSWORD_FIELD_VALUE";
const USER_RESEND_VERIFICATION_FIELD_VALUE =
  "USER_RESEND_VERIFICATION_FIELD_VALUE";
const SET_CURRENT_USER = "SET_CURRENT_USER";
const FETCH_SUPERVISORS = "FETCH_SUPERVISORS";
const FETCH_PROJECT_MANAGERS = "FETCH_PROJECT_MANAGERS";
const FETCH_PROJECT_SPONSORS = "FETCH_PROJECT_SPONSORS";
const FETCH_SUBORDINATES = "FETCH_SUBORDINATES";
const SET_DEFAULT_ROLE = "SET_DEFAULT_ROLE";
const FETCH_USERS = "FETCH_USERS";
const SET_LOGGING_IN = "SET_LOGGING_IN";
const RESET_LOGIN_FIELDS = "RESET_LOGIN_FIELDS";
const SET_RESETTING_PASSWORD = "SET_RESETTING_PASSWORD";
const SET_VERIFICATION_CODE = "SET_VERIFICATION_CODE";
const USER_FILTER = "USER_FILTER";
const CLEAR_USERS = "CLEAR_USERS";
const SET_USER_OTP = "SET_USER_OTP";

export const SET_USERS_PAGINATION = "SET_USERS_PAGINATION";
export const RESET_USERS_PAGINATION = "RESET_USERS_PAGINATION";

export const PORTAL_ADMIN = 1;
export const MANAGER = 2;
export const TEAM_LEADER = 3;
export const EMPLOYEE = 4;
export const PROJECT_SPONSOR = 5;
export const PROJECT_ADMIN = 6;
export const HR_ADMIN = 7;
export const FINANCE_APPROVER = 8;
export const FINANCE_REPORTER = 9;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const fetchSupervisors = () => {
  return (dispatch) => {
    client()
      .get("users/list", {
        params: {
          filters: {
            role: TEAM_LEADER,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const supervisors = result.data;
          dispatch({ type: FETCH_SUPERVISORS, supervisors });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const getCurrentUser = (
  successCallback = null,
  errorCallback = null,
  paramRoleId = null
) => {
  return (dispatch) => {
    client()
      .get("/users/get/current")
      .then((json) => {
        const result = json.data;
        if (result) {
          const resData = result.data;
          dispatch({ type: SET_CURRENT_USER, user: resData });
          dispatch(fetchMemberProjects(resData.id));
          const roles = resData.roles;
          if (typeof roles !== "undefined") {
            if (paramRoleId) {
              roles
                .filter((data) => {
                  if (data.id === +paramRoleId) {
                    return data;
                  }
                  return false;
                })
                .forEach((role) => {
                  dispatch(setDefaultRole(role));
                });
            } else {
              roles.forEach((role, key) => {
                if (key === 0 && !Cache.getItem("roleId")) {
                  dispatch(setDefaultRole(role));
                }
              });
            }
          }

          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
        if (errorCallback) {
          errorCallback();
        }
      });
  };
};

export const getUser = (id) => {
  return (dispatch, getState) => {
    const user = getState().users.user;
    if (Object.keys(user).length === 0) {
      client()
        .get("users/get", {
          params: {
            id,
          },
        })
        .then((json) => {
          const result = json.data;
          if (result) {
            const user = result.data;
            if (typeof user.band !== "undefined" && user.band) {
              Object.assign(user, { band_id: user.band.id });
            }

            if (typeof user.group !== "undefined" && user.group) {
              Object.assign(user, { group_id: user.group.id });
            }

            dispatch({ type: SET_USER, user });
          }
        })
        .catch((error) => {
          dispatch(displayError(error));
        });
    }
  };
};

export const setUser = (user) => {
  return (dispatch) => {
    dispatch({ type: SET_USER, user });
  };
};

export const resetUser = () => {
  return (dispatch) => {
    dispatch({ type: RESET_USER });
  };
};

export const setDefaultRole = (role) => {
  return (dispatch) => {
    dispatch({ type: SET_DEFAULT_ROLE, role });
    Cache.setItem("roleId", role.id);
  };
};

//changes
export const logoutUser = (callback) => {
  return (dispatch) => {
    client()
      .get("/users/logout")
      .then((json) => {
        //const result = json.data;
        //if (result) {
        Cache.removeItem("apiToken");
        Cache.removeItem("userId");
        Cache.removeItem("roleId");
        localStorage.removeItem("cachedToken");
        localStorage.removeItem("otpInProgress");
        localStorage.removeItem("handleVerifyOtp");
        dispatch(resetUserLogin());
        dispatch(handleLoginFields({ target: { id: "username", value: "" } }));
        dispatch(handleLoginFields({ target: { id: "password", value: "" } }));
        callback();
        //}
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const resetUserLogin = () => {
  return (dispatch) => {
    dispatch({ type: RESET_LOGIN_FIELDS });
  };
};

export const fetchProjectManagers = () => {
  return (dispatch) => {
    client()
      .get("users/list", {
        params: {
          filters: {
            role: MANAGER,
            is_disabled: 0,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const projectManagers = result.data;
          dispatch({ type: FETCH_PROJECT_MANAGERS, projectManagers });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchProjectSponsors = () => {
  return (dispatch) => {
    client()
      .get("users/list", {
        params: {
          filters: {
            role: PROJECT_SPONSOR,
            is_disabled: 0,
          },
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const projectSponsors = result.data;
          dispatch({ type: FETCH_PROJECT_SPONSORS, projectSponsors });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchSubordinates = (
  supervisorId,
  includeDisabledUsers = false
) => {
  return (dispatch) => {
    let filters = {
      supervisor_id: supervisorId,
    };

    if (!includeDisabledUsers) {
      filters.is_disabled = 0;
    }

    client()
      .get("users/list", {
        params: {
          filters,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const subordinates = result.data;
          dispatch({ type: FETCH_SUBORDINATES, subordinates });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const createUser = (successCallback, finalCallback) => {
  return (dispatch, getState) => {
    const user = getState().users.user;

    client()
      .post("users/create", user)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            createUserCostCenter(
              result.data.id,
              user.costCenter,
              user.effectivity_date
            )
          );
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "User has been successfully created."
            )
          );
          //reset user
          dispatch({ type: RESET_USER });
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const updateUser = (successCallback, finalCallback, errorCallback) => {
  return (dispatch, getState) => {
    const user = getState().users.user;
    if (typeof user.roles !== "undefined") {
      let userRoles = user.roles;
      userRoles = userRoles.map((userRole) => {
        if (typeof userRole === "object") {
          return userRole.id;
        } else {
          return userRole;
        }
      });

      Object.assign(user, { roles: userRoles });
    }

    if (typeof user.department === "object") {
      const department = user.department;
      if (department && typeof department.id !== "undefined") {
        Object.assign(user, { department: department.id });
      }
    }

    // if (isNaN(user.employee_id)) {
    //   dispatch(toggleShowAlert(true, ERROR_ALERT, "Employee ID must be a number"));
    //   if (errorCallback) {
    //     errorCallback();
    //   }
    //   return false;
    // }

    client()
      .put("users/update", user)
      .then((json) => {
        const result = json.data;

        if (result) {
          let costCenterIdChange = "";
          let effDateChange = "";

          if (typeof user.cost_center_id !== "undefined") {
            costCenterIdChange = user.cost_center_id;
          }

          if (typeof user.effectivity_date !== "undefined") {
            effDateChange = user.effectivity_date;
          }

          if (costCenterIdChange !== "" || effDateChange !== "") {
            if (user.user_cost_center && user.user_cost_center.length > 0) {
                const firstCostCenter = user.user_cost_center[0];
                if (costCenterIdChange === "") {
                    costCenterIdChange = firstCostCenter.cost_center_id;
                }
                 dispatch(
                    updateUserCostCenter(user.id, costCenterIdChange, effDateChange)
                );
            } else if (costCenterIdChange !== "") {
                // if no cost center is assigned yet, we can still create one.
                dispatch(
                    createUserCostCenter(user.id, costCenterIdChange, effDateChange)
                );
            }
          }

          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "User has been successfully updated."
            )
          );
          //reset user
          dispatch({ type: RESET_USER });
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const fetchUsers = (filters = null, callback = null) => {
  return (dispatch, getState) => {
    const params = {};

    if (filters) {
      Object.assign(params, { filters: filters });
    }

    client()
      .get("users/list", {
        params,
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let data = result.data;
          if (data.length === 0) {
            data = null;
          }

          if (data) {
            let numItems = data.length;
            let min = getState().users.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE ? numItems : getState().users.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_USERS_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }

          dispatch({ type: FETCH_USERS, users: data });

          if (callback) {
            callback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const trashUser = (id) => {
  return (dispatch) => {
    client()
      .get("users/trash", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "User has been successfully deleted."
            )
          );
          dispatch(fetchUsers());
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const loginUser = (successCallback) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_LOGGING_IN, loggingIn: true });
    const loginCredentials = getState().users.login;
    client()
      .post("/users/login", loginCredentials)
      .then((json) => {
        const result = json.data;
        if (result) {
          const code = result.code;
          if (code === "SUCCESS") {
            // if (result.data) {
            //   console.log(result.data);
            //   // start lipat

            //   //end lipat
            //   successCallback();
            // }
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
        dispatch({ type: SET_LOGGING_IN, loggingIn: false });
      });
  };
};

export const handleLoginFields = (e) => {
  return (dispatch) => {
    const value = {
      [e.target.id]: e.target.value,
    };
    dispatch({ type: USER_LOGIN_FIELD_VALUE, value });
  };
};

export const handleOtpField = (e) => {
  return (dispatch) => {
    const value = e;
    console.log(value);
    dispatch({ type: SET_USER_OTP, otp: value });
  };
};

export const handleSendOtp = (e) => {
  return (dispatch, getState) => {
    const loginCredentials = getState().users.login;

    const params = {
      email: loginCredentials.username,
    };

    client()
      .post("/otp/send", params)
      .then((json) => {});
  };
};

export const handleVerifyOtp = (successCallback, errorCallback) => {
  return (dispatch, getState) => {
    const user = getState().users;

    console.log(user);

    const params = {
      email: user.login.username,
      otp: user.otp,
    };

    client()
      .post("/otp/verify", params)
      .then((res) => {
        if (res.status == "200") {
          //lipat here
          const resData = res.data.data;
          console.log(res);
          Cache.setItem("apiToken", resData.api_token);
          Cache.setItem("userId", resData.id);
          dispatch({ type: SET_CURRENT_USER, user: resData });
          dispatch(fetchMemberProjects(resData.id));
          const roles = resData.roles;
          if (typeof roles !== "undefined") {
            roles.forEach((role, key) => {
              if (key === 0) {
                dispatch(setDefaultRole(role));
              }
            });
          }
          dispatch({ type: SET_LOGGING_IN, loggingIn: false });
          successCallback();
        }
      })
      .catch((error) => {
        errorCallback();
      });
  };
};

export const handleOTPcancel = (e) => {
  return (dispatch) => {
    dispatch({ type: SET_LOGGING_IN, loggingIn: false });
  };
};

export const handleResetPasswordFields = (e) => {
  return (dispatch) => {
    const value = {
      [e.target.id]: e.target.value,
    };
    dispatch({ type: USER_RESET_PASSWORD_FIELD_VALUE, value });
  };
};

export const handleResendVerificationField = (e) => {
  return (dispatch) => {
    const value = {
      [e.target.id]: e.target.value,
    };
    dispatch({ type: USER_RESEND_VERIFICATION_FIELD_VALUE, value });
  };
};

export const handleFieldChange = (e, definedValue) => {
  return (dispatch, getState) => {
    let value = {};

    if (e) {
      if (e.target.name === "roles") {
        const role = parseInt(e.target.value);
        let roles = getState().users.user.roles || [];
        if (e.target.checked) {
          value = {
            roles: [...roles, role],
          };
        } else {
          roles = roles
            .filter((data) => {
              let currentRole = data.id;

              if (typeof currentRole === "undefined") {
                currentRole = data;
              }

              if (currentRole !== role) {
                return data;
              }

              return null;
            })
            .map((role) => {
              return role;
            });

          value = {
            roles,
          };
        }
      } else {
        /*
      else if (e.target.name === "employee_id" && e.target.value) {
        if (isNaN(+e.target.value)) {
          dispatch(toggleShowAlert(true, ERROR_ALERT, "Employee ID must be a number"));
        } else {
          value = {
            [e.target.id]: +e.target.value
          }
        }
      }
      */
        value = {
          [e.target.id]: e.target.value,
        };
      }
    } else {
      value = definedValue;
    }

    dispatch({ type: USERS_SET_FIELD_VALUE, value });
  };
};

export const changePassword = (successCallback, finalCallback) => {
  return (dispatch, getState) => {
    const user = getState().users.user;
    user.id = Cache.getItem("userId");
    client()
      .post("users/change-password", user)
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Password has been successfully changed."
            )
          );
          //reset user
          dispatch({ type: RESET_USER });
          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const filterUsers = (filter) => {
  return (dispatch) => {
    dispatch({ type: USER_FILTER, filter });
  };
};

export const disableUser = (id) => {
  return (dispatch) => {
    client()
      .get("users/disable", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "User has been successfully disabled."
            )
          );
          dispatch(fetchUsers({ is_disabled: 0 }));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const enableUser = (id) => {
  return (dispatch) => {
    client()
      .get("users/enable", {
        params: {
          id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          dispatch(
            toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "User has been successfully enabled."
            )
          );
          dispatch(fetchUsers({ is_disabled: 1 }));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const clearUsers = () => {
  return (dispatch) => {
    dispatch({ type: CLEAR_USERS });
  };
};

export const resetPassword = (successCallback) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_RESETTING_PASSWORD, resettingPassword: true });
    const resetPasswordCredentials = getState().users.resetPassword;
    client()
      .post("users/reset-password", resetPasswordCredentials)
      .then((json) => {
        const result = json.data;
        if (result) {
          const status_message = result.status_message;
          if (status_message === "RESET_PASSWORD_REQUEST_SENT") {
            dispatch(
              toggleShowAlert(
                true,
                SUCCESS_ALERT,
                "Reset Password Verification Link has been sent to your email."
              )
            );
            dispatch({
              type: SET_RESETTING_PASSWORD,
              resettingPassword: false,
            });
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
        dispatch({ type: SET_RESETTING_PASSWORD, resettingPassword: false });
      });
  };
};

export const resendVerificationCode = (successCallback) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_VERIFICATION_CODE, resendingVerificationCode: true });
    const resendVerification = getState().users.resendVerification;
    client()
      .post("users/resend-verification-code", resendVerification)
      .then((json) => {
        const result = json.data;
        if (result) {
          const status_message = result.status_message;
          if (status_message === "VERIFICATION_REQUEST_SENT") {
            dispatch(
              toggleShowAlert(
                true,
                SUCCESS_ALERT,
                "Verification Link has been sent to your email."
              )
            );
            dispatch({
              type: SET_VERIFICATION_CODE,
              resendingVerificationCode: false,
            });
            successCallback();
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
        dispatch({
          type: SET_VERIFICATION_CODE,
          resendingVerificationCode: false,
        });
      });
  };
};

export const fetchNonICRoles = () => {
  return [
    PROJECT_ADMIN,
    MANAGER,
    PORTAL_ADMIN,
    HR_ADMIN,
    FINANCE_APPROVER,
    PROJECT_SPONSOR,
    TEAM_LEADER,
  ];
};
